import { CalendarV2SupplyEvent } from "@/shared/models/economic-calendar-v2/CalendarV2Event";
import { formatNumber } from "./common";
import { ClassificationBadge, DetailStat } from "./presentational";

/**
 * Trailing cells for a `supply` (bond auction) row: EVENT + a detail cell
 * spanning the seven figure columns.
 */
export function SupplyRowCells({ event }: { event: CalendarV2SupplyEvent }) {
  return (
    <>
      <td className="px-1 whitespace-normal leading-normal min-w-[150px]">
        <p>
          <ClassificationBadge label="Supply" />
          {event.summary}
        </p>
      </td>
      <td colSpan={7} className="px-1 whitespace-nowrap">
        <div className="flex flex-wrap items-center gap-x-3 gap-y-0.5">
          <DetailStat label="B/C" value={formatNumber(event.bc_actual)} />
          <DetailStat
            label="B/C Prev"
            value={formatNumber(event.bc_previous)}
          />
          <DetailStat
            label="Avg Yld"
            value={formatNumber(event.average_actual)}
          />
          <DetailStat label="Tail" value={formatNumber(event.tail_actual)} />
          <DetailStat
            label="Sold"
            value={formatNumber(event.sold_quantity, { compact: true })}
          />
          {event.isin && (
            <DetailStat
              label="ISIN"
              value={<span className="font-mono">{event.isin}</span>}
            />
          )}
        </div>
      </td>
    </>
  );
}
